import { FC, ReactElement, ReactNode, useEffect, useState } from 'react';
import { AlertBar, ImportantNote } from '@digital-pulse/react';
import useAlertProvider from './useAlertProvider';

import styles from './alert.module.scss';

interface AlertProps {
  title: ReactNode;
  children?: ReactNode;
  footerContent: ReactNode;
  error?: boolean;
  info?: boolean;
}

const Alert: FC<AlertProps> = ({
  title,
  children,
  footerContent,
  error = true,
  info = false
}): ReactElement => {
  const { alerts } = useAlertProvider();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(key + 1);
  }, [alerts]);

  if (info) {
    return (
      <ImportantNote
        has-focus="true"
        has-close="false"
        variant="warning"
        key={key}
        className={styles.important_note_warning}
        renderHeading={title && <h2>{title}</h2>}
        renderFooter={footerContent && <div slot="footer">{footerContent}</div>}
      >
        {children && <div className={styles.alert__description}>{children}</div>}
      </ImportantNote>
    );
  }
  return (
    <AlertBar
      renderHeading={
        title && (
          <>
            <h2 slot="heading" className={styles.alert__title}>
              {title}
            </h2>
          </>
        )
      }
      renderFooter={
        <>
          <div className={styles.alert__description}>{children}</div>
          {footerContent && <div slot="footer">{footerContent}</div>}
        </>
      }
      className={styles.alert_container}
      key={key}
    ></AlertBar>
  );
};

export default Alert;
